var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "el-dialog",
    {
      staticClass: "dialog-item",
      attrs: {
        visible: _vm._visible,
        title: _vm.title,
        center: "",
        width: _vm.width,
        "lock-scroll": "",
        "close-on-click-modal": false,
      },
      on: { close: _vm.close },
    },
    [
      _vm._t("default"),
      _c(
        "span",
        {
          staticClass: "dialog-footer",
          attrs: { slot: "footer" },
          slot: "footer",
        },
        [
          _vm.button.left
            ? _c(
                "el-button",
                { staticClass: "btn cancel-btn", on: { click: _vm.cancel } },
                [_vm._v(_vm._s(_vm.button.left))]
              )
            : _vm._e(),
          _vm.button.right
            ? _c(
                "el-button",
                {
                  staticClass: "btn comfirm-btn",
                  attrs: {
                    type: "primary",
                    loading: _vm.loading,
                    disabled: _vm.buttonDisabledRight,
                  },
                  on: { click: _vm.comfirm },
                },
                [_vm._v(_vm._s(_vm.button.right))]
              )
            : _vm._e(),
        ],
        1
      ),
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }